enum InviteCTATypeEnum {
  Register = 0,
  EditResponse = 1,
  EventAccess = 2,
  EventWebPage = 3,
}

export default InviteCTATypeEnum;
